import { useUser } from '@/client/context/user'
import type { Query } from '@/client/query'

import SoftLink from '@/components/UI/SoftLink'

import getSessionBoxProps from './getSessionBoxProps'
import SessionBox from './SessionBox'

const SessionBoxFromQuery: React.FC<{
  session: Query
  hideEntrypoint?: boolean
}> = ({ session, hideEntrypoint = false }) => {
  const user = useUser()
  const props = getSessionBoxProps({ session, currentUserId: user.id })

  const component = <SessionBox {...props} hideEntrypoint={hideEntrypoint} />

  return hideEntrypoint ? component : <SoftLink href={props.link}>{component}</SoftLink>
}

export default SessionBoxFromQuery
